const defaultPagination = {
	skip: 0,
	take: 30,
};
const RequestParamsTypeEnum = {
	FORM_DATA: 'FORM_DATA',
	QUERY_STRING: 'QUERY_STRING',
};

const LIST_DATA_TAKE_ITEMS_MARGIN = 10;
const DEFAULT_TAKE = 30;
const LIST_ITEM_DEFAULT_EMPTY_PLACEHOLDER = '-';
const EXCLUDE_DEFAULT_FILTER_PARTIAL_KEYS = ['sortorder'];
const DEFAULT_SKIP_FILTER_VALUES_KEYS = ['savedfilter', 'skip', 'take'];

export {
	DEFAULT_SKIP_FILTER_VALUES_KEYS,
	defaultPagination,
	RequestParamsTypeEnum,
	LIST_DATA_TAKE_ITEMS_MARGIN,
	DEFAULT_TAKE,
	LIST_ITEM_DEFAULT_EMPTY_PLACEHOLDER,
	EXCLUDE_DEFAULT_FILTER_PARTIAL_KEYS,
};
